import React from 'react'

export default function BusinessOwners() {
    return (
        <div>
            <p>
                Small business owners have unique risks and opportunities. For many, maintaining a 
                positive cash flow and a stable balance sheet can be an ongoing battle that consumes 
                virtually all of their time. Often the more financial success you have the more time it takes to manage it. 
            </p>
            <p>
                Retirement often seems like a distant speck on the horizon. We can help you plan for your financial future. 
                By evaluating financial statements and cash flow we can assist in identifying strengths and weaknesses 
                in your business. Increasing cash flow can lead to your ability to save more which ultimately leads to a 
                more secure retirement.
            </p>
            <p>
                Death, Disability, Divorce or Departure of a key employee or owner can mean a sudden end to a successful business. 
                Implementing a plan now that addresses these issues can be paramount to the future viability of the business. 
                We guide our clients through a risk identification process and provide education on strategies to protect 
                the business for their families, employees, and future generations. 
            </p>
            <p>
                Many business owners also realize a retirement goal includes selling their business. 
                Business Succession Planning includes identifying the next generation of management, retaining key employees, 
                when and how to transfer the business, and how to minimize the impact of taxes on the transfer. 
                We work closely with business attorneys and tax preparers to ensure that the most efficient solutions 
                are implemented.
            </p>
        </div>
    )
}